<template>
  <div class="ad-card">
    <div class="ad-card-header w100 is-hidden-touch">
      <div class="is-flex is-flex-center">
        <a :href="website_link" target="_blank">
          <img class="ad-logo" :src="company_logo" />
        </a>
        <div>
          <a :href="website_link" target="_blank">
            <p class="title is-4">{{company_name}}</p>
          </a>
          <p class="partner-title subtitle is-6">
            {{role_title}}
            <i :class="role_icon"></i>
          </p>
        </div>
      </div>
      <p class="partner-title mr-6">Sponsored Ad</p>
    </div>
    <div class="ad-card-header w100 is-hidden-desktop">
      <a :href="website_link" target="_blank">
        <img class="ad-logo" :src="company_logo" />
      </a>
      <div>
        <a :href="website_link" target="_blank">
          <p class="title is-4">{{company_name}}</p>
        </a>
        <p class="partner-title subtitle is-6">
          {{role_title}}
          <i :class="role_icon"></i>
        </p>
        <p class="partner-title subtitle sponsor-mobile">Sponsored Ad</p>
      </div>
    </div>
    <hr />
    <div class="ad-content is-hidden-desktop">
      <slot name="content"></slot>
    </div>
    <div class="ad-card-banner w100 is-hidden-desktop" :style="render_banner_background"></div>
    <div class="desktop-container is-hidden-touch">
      <a :href="website_link" target="_blank">
        <div class="ad-card-banner" :style="render_banner_background"></div>
      </a>
      <div class="ad-content">
        <slot name="content"></slot>
      </div>
    </div>
    <div class="ad-card-footer w100">
      <div>
        <p class="tt-upper website-title title is-6">{{website_name}}</p>
        <p class="subtitle website-subtitle is-6">{{footer_tag}}</p>
      </div>
      <a
        :href="website_link"
        target="_blank"
        class="button search-button slide-left"
      >{{button_text}}</a>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    render_banner_background() {
      return {
        "background-image": `url('${this.banner}')`
      };
    }
  },
  props: {
    banner: {
      type: String,
      required: true
    },
    button_text: {
      type: String,
      required: true
    },
    company_logo: {
      type: String,
      required: true
    },
    company_name: {
      type: String,
      required: true
    },
    footer_tag: {
      type: String,
      required: false
    },
    role_icon: {
      type: String,
      required: false
    },
    role_title: {
      type: String,
      required: true
    },
    website_link: {
      type: String,
      required: true
    },
    website_name: {
      type: String,
      required: true
    }
  }
};
</script>


<style lang="scss" scoped>
.ad-card {
  background-color: #fff;
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.02);
  color: #4a4a4a;
  display: block;
  margin: 1rem;
}

.ad-card-header {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0.5rem;
}

@media (max-width: 768px) {
  .ad-card-header {
    justify-content: flex-start;
  }
  .subtitle {
      margin-bottom: 0 !important;
  }
}

.ad-content {
  padding: 0.5rem;
}

.ad-card-footer {
  background: #333;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
}

.ad-card-banner {
  background-position: center;
  background-size: cover;
  height: 175px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ad-logo {
  width: 60px;
  height: 60px;
  margin: 0.25rem;
  border-radius: 100%;
  border: 1px solid rgba(202, 201, 201, 0.9);
}

.desktop-container {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  .ad-card-banner {
    height: 260px;
    width: 400px;
  }
  .ad-content {
    font-size: 1.5rem;
    padding: 1rem;
  }
}

hr {
  margin: 0;
}

@media (max-width: 500px) {
  .button {
    font-size: 0.75rem;
  }
}

.image {
  max-width: 12rem;
}

.is-flex-center {
  align-items: center;
  justify-content: center;
}

.tt-upper {
  text-transform: uppercase;
}

i {
  color: #00c5fd;
  margin: 0 0.125rem;
}

.partner-title {
  color: rgb(131, 131, 131);
}

.sponsor-mobile {
    font-size: 0.75rem;
}

.website-title {
  color: rgba(202, 201, 201, 0.4);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.website-subtitle {
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>